import SharedHelper from '@/Helpers/Shared';
export default {
  inject: ['load'],
  mixins: [SharedHelper],
  data() {
    return {
      allUsersNotifications: [],
    };
  },
  methods: {
    getAllUserNotificationsOnFirstLoad: function () {
      const roleId = [...this.$store.state?.userModule.roleId]?.find((id) => id === 2);
      const params = { roleId };
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('getAllUserNotificationsDispatch', params)
        .then(() => {
          if (this.$store.state.UserNotifications800Module.successFlag) {
            const data = this.$store.state.UserNotifications800Module.allUserNotifications;
            //   this.allNotifications = this.transformNotificationsList(data);
            this.allUsersNotifications = data;
          } else {
            if (this.$store.state.UserNotifications800Module.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.getAllUserNotificationsForFirstTime(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.UserNotifications800Module.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.getAllUserNotificationsForFirstTime(params);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.onError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    getAllUserNotificationsOnSignal: function () {
      const roleId = [...this.$store.state?.userModule.roleId]?.find((id) => id === 2);
      const params = { roleId };
      this.$store.dispatch('getAllUserNotificationsDispatch', params).then(() => {
        if (this.$store.state.UserNotifications800Module.successFlag) {
          const data = this.$store.state.UserNotifications800Module.allUserNotifications;
          this.allUsersNotifications = data;
        } else {
          if (this.$store.state.UserNotifications800Module.errorStatus) {
            this.$store.dispatch('refreshToken').then(() => {
              if (this.$store.state.userModule.successFlag) {
                this.getAllUserNotificationsOnSignal(params);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else if (this.$store.state.UserNotifications800Module.error400) {
            this.$store.dispatch('csrf').then(() => {
              if (this.$store.state.loginModule.successFlag) {
                this.getAllUserNotificationsOnSignal(params);
              } else {
                this.$router.push({ name: 'login' });
              }
            });
          } else {
            this.onError();
          }
        }
      });
    },
    setUserNotificationSeen: function (dispatchNotificationId, title) {
      const params = {
        dispatchNotificationId,
      };
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('setUserNotificationSeenDispatch', params)
        .then(() => {
          if (this.$store.state.UserNotifications800Module.successFlag) {
            this.getAllUserNotificationsOnSignal();
            this.showSuccessAlert(`اعلان ${title} مشاهده شد.`);
          } else {
            if (this.$store.state.UserNotifications800Module.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.setUserNotificationSeen(dispatchNotificationId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.UserNotifications800Module.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.setUserNotificationSeen(dispatchNotificationId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.onError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
    setUserNotificationUnseen: function (dispatchNotificationId, title) {
      const params = {
        dispatchNotificationId,
      };
      if (!this.load.val) {
        this.load.val = true;
      }
      this.$store
        .dispatch('setUserNotificationUnseenDispatch', params)
        .then(() => {
          if (this.$store.state.UserNotifications800Module.successFlag) {
            this.getAllUserNotificationsOnSignal();
            this.showSuccessAlert(`اعلان ${title} به عنوان مشاهده نشده ثبت شد.`);
          } else {
            if (this.$store.state.UserNotifications800Module.errorStatus) {
              this.$store.dispatch('refreshToken').then(() => {
                if (this.$store.state.userModule.successFlag) {
                  this.setUserNotificationUnseen(dispatchNotificationId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else if (this.$store.state.UserNotifications800Module.error400) {
              this.$store.dispatch('csrf').then(() => {
                if (this.$store.state.loginModule.successFlag) {
                  this.setUserNotificationUnseen(dispatchNotificationId);
                } else {
                  this.$router.push({ name: 'login' });
                }
              });
            } else {
              this.onError();
            }
          }
        })
        .finally(() => {
          if (this.load.val) {
            this.load.val = false;
          }
        });
    },
  },
};
